import { API_URL } from "../../../../setup/config/env"

export const queryGoogleCalendar = async (startDate, endDate, consultationTypeId = null) => {
    try {
        let url = `${API_URL}/api/calendar/list`;
        const params = [];
        if (startDate && endDate) {
            params.push(`timeMin=${encodeURIComponent(startDate)}`);
            params.push(`timeMax=${encodeURIComponent(endDate)}`);
        }
        if (consultationTypeId) {
            params.push(`consultationTypeId=${encodeURIComponent(consultationTypeId)}`);
        }
        if (params.length > 0) {
            url += `?${params.join('&')}`;
        }

        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error querying Google Calendar:", error);
        throw error;
    }
}

export const getCalendarSettings = async () => {
    try {
        const response = await fetch(`${API_URL}/api/calendar/settings?includeDisabled=true`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching calendar settings:", error);
        throw error;
    }
}

export const isAuthenticated = async () => {
    try {
        const response = await fetch(`${API_URL}/api/calendar/isAuthenticated`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response;
    } catch (error) {
        console.error("Error checking authentication", error);
        throw error;
    }
}